export default __webpack_public_path__ + "media/images/ecroue-46a81c1e1fa877172e577fa907bec217.png";